import { TrafficType } from '../types';
import { GetBrandClassificationMetricsResponse } from '../Total/hooks/useBrandClassificationMetrics';
import { weekIdToTimestamp } from 'src/utils/dateUtils';

/**
 * Combines the branded and unbranded responses into an array for a spline chart
 */
export function brandClassificationResponseToSpline(
  response: GetBrandClassificationMetricsResponse,
  trafficType: TrafficType | 'totalTrafficKeywordCount' | 'organicTrafficKeywordCount'
): number[][] {
  const weekIdToTotalTrafficMap = response.records.reduce((acc, record) => {
    if (!acc.has(record.weekId)) {
      acc.set(record.weekId, 0);
    }
    acc.set(record.weekId, acc.get(record.weekId) + record[trafficType]);
    return acc;
  }, new Map<number, number>());

  return Array.from(weekIdToTotalTrafficMap.keys())
    .sort((a, b) => a - b)
    .map((weekId) => [weekIdToTimestamp(weekId), weekIdToTotalTrafficMap.get(weekId) ?? 0]);
}
